import { fetch, buildUrl } from 'domain/Api';
import { ApiCall } from 'omni-common-ui';

export const FETCH_READER_RESULTS_REQUEST = 'FETCH_READER_RESULTS_REQUEST';
export const FETCH_READER_RESULTS_SUCCESS = 'FETCH_READER_RESULTS_SUCCESS';
export const FETCH_READER_RESULTS_FAILURE = 'FETCH_READER_RESULTS_FAILURE';

const buildReaderUrl = (groupId) => buildUrl(`/groups/${groupId}/reader-results`);

export function fetchReaderIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildReaderUrl(groupId) })) {
      return false;
    }

    return dispatch(fetchReader(groupId));
  };
}

export function fetchReader(groupId) {
  return (dispatch) => {
    const url = buildReaderUrl(groupId);
    const method = 'GET';

    return dispatch(fetchReaderRequest()).payload
      .then((response) => dispatch(fetchReaderSuccess(response)))
      .catch((error) => dispatch(fetchReaderFailure(error)));

    function fetchReaderRequest() {
      return ApiCall.createAction({
        type: FETCH_READER_RESULTS_REQUEST,
        payload: fetch(url),
        url,
        method,
        groupId,
      });
    }

    function fetchReaderSuccess(payload) {
      return ApiCall.createAction({
        type: FETCH_READER_RESULTS_SUCCESS,
        payload,
        url,
        method,
        groupId,
      });
    }

    function fetchReaderFailure(error) {
      return ApiCall.createAction({
        type: FETCH_READER_RESULTS_FAILURE,
        error,
        url,
        method,
        groupId,
      });
    }
  };
}



// WEBPACK FOOTER //
// ./data/Reader/actions.js